import InvoiceListLayout from "./list/InvoiceListLayout.vue";
import DetailLayout from "./detail/DetailLayout.vue";
import ClientMangerCard from "./cards/ClientMangerCard.vue";
import BrandCard from "./cards/BrandCard.vue";


export default {
    'invoice-list-page' : InvoiceListLayout,
    'invoice-detail-page' : DetailLayout,
    'cm-dash-card' : ClientMangerCard,
    'brand-dash-card' : BrandCard,
};